import React from 'react';
import './css/requestCertificateCard.css';
import { Doc, DocDisabled } from '../../constants';

interface RequestCertificateCardProps {
  onRequestClick: () => void;
  isEnabled: boolean;
  hasPendingRequests: boolean;
}

const RequestCertificateCard: React.FC<RequestCertificateCardProps> = ({ onRequestClick, isEnabled, hasPendingRequests }) => {
// console.log(isEnabled, hasPendingRequests,'-')
  let shouldDisable = !isEnabled ? true : (isEnabled && hasPendingRequests) ? true : false;
  return(
  <div className={`request-card ${shouldDisable ? 'disabled' : ''}`}>
    <div className="request-card-content">
      <p className="request-card-text">
        {shouldDisable ? (hasPendingRequests? "Request already in process. New request cannot be raised.":"New requests are currently unavailable!")
        :"Need a Principal Certificate for your business?"}
      </p>
      <button className="request-card-button" onClick={onRequestClick}>
        Request Now
      </button>
    </div>
    <div className="request-card-icon">
     <img src={shouldDisable? DocDisabled:Doc} alt="" style={{height:30}} />
    </div>
  </div>
)
};

export default RequestCertificateCard;
